import Header from "../Header/Header";
import React,{useState} from "react";
import Footer from "../Footer/Footer";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LoginForm from "./LogInForm";

export default function () {
    const [passwordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return <>
        <Header/>

        <LoginForm/>

        <Footer/>
    </>
}